export const SERVER_PAGE_SIZE = 30;
export const SERVER_PAGE_LICENSE_APPROVAL_SIZE = 100;
export const SERVER_PAGE_DEALDER_ACTIONS_SIZE = 100;
export const API_BASE_URL = '/api/v1';

export const IMAGE_PLACEHOLDER_PLACE = "/images/ui/image-placeholder-place.svg"
export const ONLY_MY_TRANSFER_LABEL = "Only my transfers"
export const IS_ARCHIVED = 'Include Archived'
export const feildMapping = {
    nicsFee: "nics_fee",
    discountMultipleFirearms: "discount_multiple_firearms",
    suppressorFee: "suppressor_fee",
    pistolFee: "pistol_fee",
    rifleFee: "rifle_fee",
    sbrFee: "sbr_fee",
}

export enum dealerActions {
    ADD="add",
    REMOVE="remove"
}

export const ezMessageMapping = {
    '0': 'EZ check successful.',
    '30': 'EZ check failed.',
    '31': 'EZ check failed: License expired.',
    '33': 'EZ check failed: Unrecognized License.',
    '32': 'EZ check failed.',
}

export const emailDomain = '@masterffl.com'

export const QUEUE_GRID_TOOLTIP = {
    transcodeTooltip: 'The transfer code is produced by MasterFFL and is unique for each transfer.',
    orderNumberTooltip: 'The order number is pulled in from the Sending Dealer’s online store.',
    ageTooltip :'The amount of time since the transfer was initiated',
}

export enum eCommercePlatform {
    MAGENTO="Magento",
    BIG_COMMERCE="BigCommerce",
    WOO_COMMERCE="WooCommerce"
}

